import React from "react";

//import logo from "assets/images/logo.svg";

import { HashRouter as Router, Link, Route, Switch } from "react-router-dom";
import { translate } from "react-i18next";
import { withRouter } from "react-router-dom";
 
import MenueItem from "./menue-item"; 
import UserMenue from "./user-menu";
import TestMenu from "./test-menu";
import SearchMenu from "./search-menu"; 
 
class Navigation extends React.Component {
  constructor(props) {
    super(props);
    this.status = {
    };
  }

  updateNavigation() {
    this.forceUpdate();
  }

  render() {
    const { t } = this.props;

    return (
      <div>
        <div className="navbar-wrapper">
          <div className="container">
            <nav className="navbar navbar-inverse navbar-static-top">
              <div className="container">
                <div className="navbar-header">
                  <button
                    type="button"
                    className="navbar-toggle collapsed"
                    data-toggle="collapse"
                    data-target="#navbar"
                  >
                    <span className="icon-bar" />
                    <span className="icon-bar" />
                    <span className="icon-bar" />
                  </button>
                  {/* logo = home Button*/}
                  <Link to="/" className="navbar-brand">
                    <img
                      src={process.env.PUBLIC_URL + "/assets/images/logo.svg"}
                      className="logo"
                      alt="logo"
                    />
                  </Link>
                </div>
                <div id="navbar" className="collapse navbar-collapse">
                  <ul className="nav navbar-nav">
                    {/* <MenueItem title="home" to="/home" />*/}
                    <MenueItem title="about" to="/about" />
                    <MenueItem title="tictactoe" to="/tictactoe" />
                    <SearchMenu />
                    <TestMenu />
                    <UserMenue />
                  </ul>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    );
  }
}

export default Navigation;
